"use client";

import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Sparkles, FileText, Code2 } from "lucide-react";

/**
 * 3D-Bühne + rotierender Laser-Filter im Hintergrund,
 * gestochen scharfe Karten im Vordergrund.
 */
export default function Preview() {
  const [purified, setPurified] = useState(false);

  useEffect(() => {
    const id = setInterval(() => setPurified((v) => !v), 2400);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      aria-hidden="true"
      className="relative flex h-full w-full items-center justify-center overflow-hidden rounded-2xl p-4 select-none"
      style={{ perspective: "900px" }}
    >
      <motion.div
        animate={{ scale: [1, 1.22, 1], opacity: [0.45, 0.85, 0.45] }}
        transition={{ duration: 4.5, repeat: Infinity }}
        className="pointer-events-none absolute left-1/2 top-1/2 h-40 w-56 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gradient-to-r from-rose-500/20 via-purple-500/30 to-emerald-500/30 blur-3xl"
      />

      <div
        className="pointer-events-none absolute inset-x-[-20%] bottom-[-35%] h-[110%] opacity-45 dark:opacity-60"
        style={{
          transform: "rotateX(68deg)",
          maskImage:
            "radial-gradient(ellipse 65% 55% at 50% 50%, black 25%, transparent 80%)",
          WebkitMaskImage:
            "radial-gradient(ellipse 65% 55% at 50% 50%, black 25%, transparent 80%)",
        }}
      >
        <motion.div
          animate={{ backgroundPosition: ["0px 0px", "0px 28px"] }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          className="h-full w-full bg-[linear-gradient(to_right,rgba(168,85,247,0.3)_1px,transparent_1px),linear-gradient(to_bottom,rgba(168,85,247,0.3)_1px,transparent_1px)] bg-[size:28px_28px]"
        />
      </div>

      {/* Gestochen scharfer Vordergrund */}
      <div className="relative z-10 flex items-center gap-3 antialiased">
        <motion.div
          animate={{
            opacity: purified ? 0.5 : 0.9,
            y: purified ? 3 : 0,
          }}
          className="flex flex-col items-center gap-1 rounded-xl border border-rose-400/60 bg-white px-2.5 py-2 shadow-md dark:bg-zinc-900"
        >
          <Code2 className="h-4 w-4 text-rose-500" />
          <span className="font-mono text-[10px] font-bold text-neutral-500 line-through">
            &lt;div&gt; Müll
          </span>
          <span className="font-mono text-[9px] font-bold text-rose-500">
            95 KB
          </span>
        </motion.div>

        <motion.div
          animate={{ rotateZ: 360 }}
          transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
          className="flex h-10 w-3 items-center justify-center rounded-full bg-gradient-to-b from-purple-500 via-fuchsia-400 to-emerald-400 shadow-[0_0_20px_#a855f7]"
        />

        <motion.div
          animate={{ y: purified ? -4 : 2 }}
          transition={{ type: "spring", stiffness: 280, damping: 20 }}
          className={`flex flex-col items-center gap-1 rounded-2xl border bg-white px-3.5 py-2.5 transition-all duration-300 dark:bg-zinc-900 ${
            purified
              ? "border-emerald-400/80 shadow-[0_16px_34px_-4px_rgba(16,185,129,0.55)]"
              : "border-purple-400/60 shadow-lg"
          }`}
        >
          <div className="flex items-center gap-1">
            <FileText className="h-4 w-4 text-emerald-500" />
            <span className="font-mono text-xs font-black text-neutral-900 dark:text-white">
              Pure .md
            </span>
          </div>
          <span className="flex items-center gap-1 rounded bg-emerald-500/15 px-1.5 py-0.5 font-mono text-[9px] font-black text-emerald-600 dark:text-emerald-400">
            <Sparkles className="h-2.5 w-2.5" />
            −84% Tokens
          </span>
        </motion.div>
      </div>
    </div>
  );
}
